import { render, staticRenderFns } from "./renderItem.vue?vue&type=template&id=84a6a70c&scoped=true&"
import script from "./renderItem.vue?vue&type=script&lang=js&"
export * from "./renderItem.vue?vue&type=script&lang=js&"
import style0 from "./renderItem.vue?vue&type=style&index=0&id=84a6a70c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a6a70c",
  null
  
)

export default component.exports